const BLOCK_ID_USER_MAIN = 'userMain';
const BLOCK_ID_USER_ACTIONS = 'userActions';
const BLOCK_ID_USER_AUTH = 'userAuth';

export {
  BLOCK_ID_USER_MAIN,
  BLOCK_ID_USER_ACTIONS,
  BLOCK_ID_USER_AUTH,
};
